import React from 'react';
import "../../styles/holidays-list/main.css";

const Main = () => {
    return (
        <div className="container holidays-list-main mt-4">
            <div className="row pt-5">
                <h2 className="my-heading">List of Holidays</h2>
                <div className="col-md-12 mb-4">
                    <br />
                    <div className="row">
                        <div className="col-md-12 mb-4">
                            <div className="pdf-container">
                                <iframe
                                    className="pdf-viewer"
                                    src="https://ccsuniversity.blr1.cdn.digitaloceanspaces.com/public/pdf/2025/01/Holiday%20List%202024-25.pdf"
                                    width={1200}
                                    height={600}
                                    title='holidays list'
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Main;